export default [
  {
    description: 'Reports',
    path: '/publicas/global/report',
    name: 'Reports',
    component: () => import('@/views/publicas/global/report.vue'),
    meta: {
      isLegacy: true,
      requiresAuth: true
    },
    goesToMenu: true,
  },
]

